__turbopack_context__.v({
  "learningPathsList": "rZ-jqW_learningPathsList",
  "learningSection": "rZ-jqW_learningSection",
  "sectionTitle": "rZ-jqW_sectionTitle",
});
